import { isBrowser } from '@emotion/utils';
import { createContext, createElement } from 'react';
import createCache from '@emotion/cache';

var hydration = {
  shouldHydrate: false
};

if (isBrowser) {
  hydration.shouldHydrate = !!document.querySelector('[data-more]');
}

function _set() {}

function _get() {
  return true;
}

if (process.env.NODE_ENV === 'test' || !isBrowser) {
  // $FlowFixMe
  Object.defineProperty(hydration, 'shouldHydrate', {
    set: _set,
    get: _get
  });
} // $FlowFixMe


var CSSContext = createContext(null);
function consumer(instance, func) {
  return createElement(CSSContext.Consumer, null, function (context) {
    if (context === null) {
      if (instance.emotionCache === undefined) {
        instance.emotionCache = createCache();
      }

      return createElement(CSSContext.Provider, {
        value: instance.emotionCache
      }, func(instance.emotionCache));
    } else {
      return func(context);
    }
  });
}

export { hydration, CSSContext, consumer };
//# sourceMappingURL=index.es.js.map



// WEBPACK FOOTER //
// ./node_modules/@emotion/core/dist/index.es.js